<div class="jb-grid one-up grid-offset-l w-100 mv3 mb4-ns mh0-override pt5">
  <div class="bt b--medium-gray">
    <div *ngIf="!feedbackSubmitted">
      <div *ngIf="!showNegativeForm" class="pt5">
        <div class="mb4">
          <p class="body-demi">{{ feedback.title }}</p>
        </div>
        <div *ngIf="showPositiveForm">
          <p class="body">
            {{
              feedback.rateYourExperienceCopy
                ? feedback.rateYourExperienceCopy
                : 'How would you rate your experience?'
            }}
          </p>
          <div class="pt2 pb5">
            <span
              *ngFor="let star of stars; let i = index"
              class="bright-blue"
              id="starRating"
            >
              <jb-icon
                [name]="
                  isHovered
                    ? hoveredStars[i] === 1
                      ? 'starFull'
                      : 'starEmpty'
                    : stars[i] === 1
                    ? 'starFull'
                    : 'starEmpty'
                "
                width="22"
                height="21"
                class="pr1"
                (click)="onStarClick(i)"
                (mouseenter)="onStarHoverIn(i)"
                (mouseleave)="onStarHoverOut()"
              >
              </jb-icon>
            </span>
          </div>
          <button
            type="button"
            jbButton
            theme="standard"
            size="small"
            class="mt4"
            id="feedbackSubmitPositiveBtn"
            (click)="submitFeedback(false, '')"
          >
            {{ feedback.submitButton }}
          </button>
        </div>
        <div *ngIf="!showPositiveForm">
          <button
            jbButton
            theme="standard"
            size="small"
            class="mr3 mb3"
            id="feedbackPositiveBtn"
            (click)="onClickPositiveFeedback()"
          >
            {{ feedback.positiveButtonLabel }}
          </button>
          <button
            jbButton
            theme="standard"
            size="small"
            id="feedbackNegativeBtn"
            (click)="onClickNegativeFeedback()"
          >
            {{ feedback.negativeButtonLabel }}
          </button>
        </div>
      </div>
      <div *ngIf="showNegativeForm">
        <form class="flex flex-column col-12-m col-10-l pt5">
          <section class="w-100 col-6-m col-6-l mt3 mt0-ns">
            <div class="mb3">
              <p class="body-demi">{{ feedback.negativeFeedbackTitle }}</p>
            </div>
            <p class="body">{{ feedback.starRatingHeader }}</p>
            <div class="pt2 pb6">
              <span
                *ngFor="let star of stars; let i = index"
                class="bright-blue"
                id="starRating"
              >
                <jb-icon
                  [name]="
                    isHovered
                      ? hoveredStars[i] === 1
                        ? 'starFull'
                        : 'starEmpty'
                      : stars[i] === 1
                      ? 'starFull'
                      : 'starEmpty'
                  "
                  width="22"
                  height="21"
                  class="pr1"
                  (click)="onStarClick(i)"
                  (mouseenter)="onStarHoverIn(i)"
                  (mouseleave)="onStarHoverOut()"
                >
                </jb-icon>
              </span>
            </div>
            <p class="body">{{ feedback.negativeFeedbackDescription }}</p>
            <jb-checkbox
              class="mt3 flex"
              *ngFor="let label of feedback.negativeCheckboxLabels"
              (valueChanged)="onCheckboxValueChange($event, label)"
            >
              {{ label }}
            </jb-checkbox>
            <jb-form-field-container class="mb3 mt3 relative">
              <jb-input-label>{{ feedback.label }}</jb-input-label>
              <textarea jbTextArea maxlength="5000" #comments></textarea>
              <span class="dib lh-title pv2 pl3 charcoal f6"
                >{{ feedback.description }}
              </span>
            </jb-form-field-container>
            <button
              type="button"
              jbButton
              theme="standard"
              size="small"
              class="mt4"
              id="feedbackSubmitNegativeBtn"
              (click)="submitFeedback(true, comments.value)"
            >
              {{ feedback.submitButton }}
            </button>
          </section>
        </form>
      </div>
    </div>
    <div *ngIf="feedbackSubmitted" class="pt5">
      <jb-body-text [content]="feedback.submittedTitle"></jb-body-text>
    </div>
  </div>
</div>
